import React, { Component, Fragment } from 'react';
import LocaleStringsListItemTranslate from './LocaleStringsListItemTranslate.js';
import LocaleStringsListItemValidate from './LocaleStringsListItemValidate.js';
import { Prompt, withRouter } from 'react-router';
import ability from '../../abilities'
import Locale from '../../Entities/Locale.js';

class LocaleStringsList extends Component {
  constructor (props) {
    super(props);

    this.state = {
      unsavedChanges: false,
      isSaving: false
    };

    this.originalValues = this.loadValuesAsOriginal(this.props.strings, this.props.mode);
    this.onSubmit = this.onSubmit.bind(this);
    this.markUnsavedStrings = this.markUnsavedStrings.bind(this);
    this.categorizeStrings(this.props.strings);
  }
  
  categorizeStrings (strings) {
    this.todoStrings = strings.filter(
      (string) => {
        switch (this.props.mode) {
          case 'validate':
            return string.props.state === 'pending';
          case 'translate':
            return (string.props.value === null || string.props.value === "") || (string.props.value && string.props.state === 'rejected');
        }
      }
    );

    this.doneStrings = strings.filter(
      (string) => {
        switch (this.props.mode) {
          case 'validate':
            return string.props.state !== 'pending';
          case 'translate':
            return string.props.value !== null && string.props.value !== "" && string.props.state !== 'rejected' || string.props.state === 'validated';
        }
      }
    );
  }

  generateStrings (strings) {
    const that = this;
    return strings.map(function (string) {
      switch (that.props.mode) {
        case 'translate': {
          return (
            <LocaleStringsListItemTranslate 
              changesBeacon={that.markUnsavedStrings} 
              key={string.props.key + '.' + that.props.locale.props.key} 
              string={string}
              isSaving={(that.state.isSaving === true && string.props.isDirty === true)}
              originalValue={that.originalValues[string.props.key]}
              readonly={that.props.readonly}
            />
          );
        }
        case 'validate': {
          return (
            <LocaleStringsListItemValidate 
              changesBeacon={that.markUnsavedStrings} 
              key={string.props.key + '.' + that.props.locale.props.key} 
              string={string}
              originalValue={that.originalValues[string.props.key]}
            />
          );
        }
      }
    });
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.unsavedChanges) {
      if (
        (this.props.locale.props.key !== nextProps.locale.props.key) || 
        (this.props.mode === 'validate' || this.props.mode !== nextProps.mode) || 
        this.state.isSaving
      ) {
        this.originalValues = this.loadValuesAsOriginal(nextProps.strings, nextProps.mode);
        this.setState({ unsavedChanges: false });
      }
    }
  }

  loadValuesAsOriginal (strings, mode) {
    const that = this;
    let values = {};

    strings.map(function (string) {
      values[string.props.key] =
        (mode === 'validate') 
          ? string.props.state 
          : (string.props.value)
            ? string.props.value
            : "";
    });

    return values;
  }

  onSubmit (e) {
    const that = this;

    that.setState({ isSaving: true });
    e.preventDefault();
    
    let updated = that.props.updater(that.props.locale.props.key, that.props.strings, that.props.mode);
    if (updated) {
      updated.then(function (updatedStrings) {

        if (that.props.mode === 'validate') {
          that.categorizeStrings(that.props.strings);
          that.originalValues = that.loadValuesAsOriginal(that.props.strings, that.props.mode);
        }

        that.setState({ unsavedChanges: false, isSaving: false });
      }).catch(function () {
        that.setState({ isSaving: false });
      })
    }
  }

  markUnsavedStrings () {
    const that = this;
    let isDirty = false;

    this.props.strings.map(function (string) {
      if (string.props.isDirty) {
        isDirty = true;
      }
    });

    if (isDirty !== this.state.unsavedChanges) {
      this.setState({ unsavedChanges: isDirty });
    }
  }

  //shouldComponentUpdate (nextProps, nextState) {
    //if (this.state.unsavedChanges !== nextState.unsavedChanges) {
    //  return true;
    //} else {
    //  return false;
    //}
  //}
  
  render () {
    let saveChangesBar = null;
    const that = this;

    saveChangesBar = !this.props.readonly && (
      <div className="level">
        <div className="level-left">
        </div>
        <div className="level-right">
          <span className="level-item">
            <input
              type="submit"
              disabled={this.state.isSaving || !this.state.unsavedChanges}
              className="button is-primary is-gradient"
              value={this.state.isSaving ? 'Saving...' : 'Save Changes'}
            />
          </span>
        </div>
      </div>
    );

    let headers = null;
    let title = null;
    switch (that.props.mode) {
      case 'translate': 
        headers = (
          <tr>
            <th style={{width: '10%'}}>Context</th>
            <th>Master</th>
            <th style={{width: '5%'}}></th>
            <th>Translation</th>
            <th style={{width: '10%'}}></th>
          </tr>
        );

        title = `Translating ${this.props.locale.props.name} (${this.props.locale.props.key})`;

        break;
      case 'validate': {
        headers = (
          <tr>
            <th>Context</th>
            <th>Master</th>
            <th>{this.props.locale.props.name} ({this.props.locale.props.key})</th>
            <th>Validated?</th>
          </tr>
        );

        title = `Validating ${this.props.locale.props.name} (${this.props.locale.props.key})`;

        break;
      }
    }

    return (
      <Fragment>
        <Prompt 
          when={this.state.unsavedChanges} 
          message={location => (
            location.pathname.startsWith(that.props.location.pathname) ? true : "You have unsaved changes on this page. Do you want to leave this page and discard your changes or stay on this page?" 
          )}
        />
        <div className="title">
          <span className="title-content">
            <h1>{title}</h1>
          </span>
        </div>
        <form onSubmit={this.onSubmit} key={'locale.strings.list.form.' + this.props.locale}>
          <div className="content">
            <h1>To Do</h1>
            <div className="table-container">
              <table className="table is-striped is-fullwidth is-scrollable" style={{tableLayout: 'fixed'}} >
                <thead>
                  {headers}
                </thead>
                <tbody>
                  {this.generateStrings(this.todoStrings)}
                </tbody>
              </table>
            </div>

            <h1>Done</h1>
            <div className="table-container">
              <table className="table is-striped is-fullwidth is-scrollable" style={{tableLayout: 'fixed'}} >
                <thead>
                  {headers}
                </thead>
                <tbody>
                  {this.generateStrings(this.doneStrings)}
                </tbody>
              </table>
            </div>
          </div>
          <div className="bottom">
            {saveChangesBar}
          </div>
        </form>
      </Fragment>
    );
  }
}

export default withRouter(LocaleStringsList);


// WEBPACK FOOTER //
// ./src/Components/LocaleStrings/LocaleStringsList.js